import React from 'react';
import Icon from './Icon';
import Text from './Text';

/**
 * EGGS Alert Component
 * Feedback messages with EGGS styling
 */
export default function Alert({
  variant = 'info',
  title,
  children,
  onClose,
  className = '',
  ...props
}) {
  const variants = {
    success: {
      bg: 'bg-green-50',
      border: 'border-green-200',
      text: 'text-green-800',
      icon: 'check-circle',
      iconColor: '#28A745'
    },
    error: {
      bg: 'bg-red-50',
      border: 'border-red-200',
      text: 'text-red-800',
      icon: 'alert-circle',
      iconColor: '#DC3545'
    },
    warning: {
      bg: 'bg-yellow-50',
      border: 'border-yellow-200',
      text: 'text-yellow-800',
      icon: 'alert-triangle',
      iconColor: '#FFC107'
    },
    info: {
      bg: 'bg-blue-50',
      border: 'border-blue-200',
      text: 'text-blue-800',
      icon: 'info',
      iconColor: '#FEC626'
    }
  };

  const config = variants[variant];

  const alertClasses = [
    'flex items-start gap-3',
    'p-4 rounded-lg border',
    config.bg,
    config.border,
    className
  ].join(' ');

  return (
    <div className={alertClasses} role="alert" {...props}>
      <Icon name={config.icon} size={20} color={config.iconColor} />
      <div className="flex-1">
        {title && (
          <Text type="Body" variant="sm" weight="Strong" className={config.text}>
            {title}
          </Text>
        )}
        <Text type="Body" variant="sm" className={config.text}>
          {children}
        </Text>
      </div>
      {onClose && (
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Close alert"
        >
          <Icon name="x" size={18} />
        </button>
      )}
    </div>
  );
}
